module.exports = __webpack_public_path__ + "/bundle/asset/admission1-2-485641671778e15c955e09a55d53911b.png";